import React from 'react';

const Loader = () => (
  <div className="flex justify-center items-center h-screen">
    <div className="w-12 h-12 border-4 border-t-transparent border-blue-500 rounded-full animate-spin"></div>
  </div>
);

export default Loader;